import axios from "axios";
let events = []
let actions = {
    getEvents(groupid){
        return new Promise((resolve,reject)=>{
            axios.get("/event",{params:{
                group: groupid
            }})
            .then(data=>{
                resolve(data.data.object);
            })
            .catch(err=>{
                console.log(err);
            })
        })
    },
    editEvent(groupid,id,name,time,message=""){
        //check if valid date
        return new Promise((resolve,reject)=>{
            let target_time = new Date(time);

            //check if not valid date object or event is behind current time
            console.log('[ON EDIT]',time);
            if(target_time.valueOf() == Number.NaN || target_time.valueOf()<= new Date().valueOf()){
                return reject("Invalid date");
            }
            let e = {
                _id:id,
                group: groupid,
                name: name,
                time: new Date(time),
                message: message
            }
            console.log("API TIME SENT",e.time);
            axios.put("/event",e)
            .then(data=>{
                resolve(data.data.object);
            })
            .catch(err=>{
                reject(err);
            })
        })
    },
    removeEvent(id){
        return new Promise((resolve,reject)=>{
            axios.delete("/event",{data:{_id:id}})
            .then(data=>{
                resolve()
            })
            .catch(err=>{
                reject(err)
            })
        })
    },
    addEvent(groupid,name,time,message=""){
        //check if valid date
        return new Promise((resolve,reject)=>{
            let target_time = new Date(time);

            //check if not valid date object or event is behind current time
            if(target_time.valueOf() == Number.NaN || target_time.valueOf()<= new Date().valueOf()){
                return reject("Invalid date");
            }
            let e = {
                _id:Math.round(Math.random()*10000),
                group: groupid,
                name: name,
                time: new Date(time),
                message: message
            }
            console.log("API TIME SENT",e.time);
            axios.post("/event",e)
            .then(data=>{
                resolve(data.data.object);
            })
            .catch(err=>{
                reject(err);
            })
        })
    }
}
export default actions;